/**
 * `FeedbackPanel` (design.md §5.1: "a scoped error panel with 'Reintentar'
 * appears"; "Previously cached data may remain visible only with 'Datos
 * anteriores' and its timestamp"; §6 "empty states explain cause and the
 * next valid action"). One shared shape for the three non-success read
 * states a feature screen needs — not a universal prop-heavy `Card`
 * (design.md §7): only `variant`/`message`/optional `onRetry`.
 */
export function FeedbackPanel({
  variant,
  message,
  onRetry,
  disabled,
}: {
  variant: "error" | "stale" | "empty";
  message: string;
  onRetry?: () => void;
  /** Codex finding 8 (panel-redesign-v3 PR #382): disables Reintentar while a background refresh for this same data is already in flight. */
  disabled?: boolean;
}) {
  // Error is the only variant that must interrupt assistive-tech users
  // immediately (role="alert"); stale/empty are informational and use a
  // polite role="status" so they never steal focus/announcement priority.
  const role = variant === "error" ? "alert" : "status";

  return (
    <div className={`v2-feedback-panel v2-feedback-panel--${variant}`} role={role}>
      <p className="v2-feedback-panel__message">
        {/* 02-componentes.md "FeedbackPanel": "punto de 8px" tone dot, same
            device StatusBadge uses — colored via currentColor so it always
            tracks whichever variant class sets this banner's foreground. */}
        <span aria-hidden="true" className="v2-feedback-panel__dot" />
        {message}
      </p>
      {onRetry && (
        <button type="button" onClick={onRetry} disabled={disabled}>
          Reintentar
        </button>
      )}
    </div>
  );
}
